/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Delete_User_ButtonInputs */

const en_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete User`)
};

const fr_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l’utilisateur`)
};

const de_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer löschen`)
};

const it_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina utente`)
};

const ru_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить пользователя`)
};

const es_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar usuario`)
};

const zh_cn2_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除用户`)
};

const ja_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーの削除`)
};

const hi_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता हटाएं`)
};

const pt_pt2_team_manager_delete_user_button = /** @type {(inputs: Team_Manager_Delete_User_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir usuário`)
};

/**
* | output |
* | --- |
* | "Delete User" |
*
* @param {Team_Manager_Delete_User_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_delete_user_button = /** @type {((inputs?: Team_Manager_Delete_User_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Delete_User_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_delete_user_button(inputs)
	if (locale === "de") return de_team_manager_delete_user_button(inputs)
	if (locale === "it") return it_team_manager_delete_user_button(inputs)
	if (locale === "ru") return ru_team_manager_delete_user_button(inputs)
	if (locale === "es") return es_team_manager_delete_user_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_delete_user_button(inputs)
	if (locale === "ja") return ja_team_manager_delete_user_button(inputs)
	if (locale === "hi") return hi_team_manager_delete_user_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_delete_user_button(inputs)
	return en_team_manager_delete_user_button(inputs)
});